export default {
  tab: {
    selectJob: 'Load selection',
  },
};
